import { gsap } from '../lib/gsap';
import { prefersReducedMotion } from '../lib/lenis';

// "Coming soon" mark idle: a bright accent comet orbits the glyph's contour
// forever over a quiet outline track, while the whole mark breathes and the
// glow pulses with it. Calm, endless, alive.
export function initComingSoon(): void {
  const root = document.querySelector<HTMLElement>('[data-coming-soon]');
  if (!root) return;

  const mark = root.querySelector<HTMLElement>('[data-cs-mark]');
  const comet = root.querySelector<SVGPathElement>('[data-cs-comet]');
  const glow = root.querySelector<HTMLElement>('[data-cs-glow]');

  if (comet) {
    const len = comet.getTotalLength();

    if (prefersReducedMotion()) {
      // Static, fully traced outline — present but silent.
      gsap.set(comet, { strokeDasharray: 'none', opacity: 0.5 });
      return;
    }

    // A comet 14% of the contour long, orbiting at constant speed. The dash
    // pattern flows through all three subpaths (outer contour + the two
    // counters), so the light visits every part of the glyph.
    const head = len * 0.14;
    gsap.set(comet, { strokeDasharray: `${head} ${len - head}`, strokeDashoffset: 0 });
    gsap.to(comet, { strokeDashoffset: -len, duration: 5, ease: 'none', repeat: -1 });
  }

  if (prefersReducedMotion()) return;

  if (mark) {
    gsap.to(mark, { scale: 1.035, duration: 2.8, ease: 'sine.inOut', yoyo: true, repeat: -1 });
  }
  if (glow) {
    gsap.to(glow, { opacity: 0.72, duration: 2.8, ease: 'sine.inOut', yoyo: true, repeat: -1 });
  }
}
